import React from 'react'

import Skeleton from 'react-loading-skeleton'

type MenuCardSkeletonProps = {
  hideItemName?: boolean
  hideItemPrice?: boolean
  hideItemDescription?: boolean
}

const MenuCardSkeleton = ({
  hideItemName,
  hideItemPrice,
  hideItemDescription
}: MenuCardSkeletonProps) => (
  <div
    className='editableMenuItemContainer'
    data-testid='menu-card-skeleton'
    aria-busy='true'
  >
    <div className='menuItemWrapper' style={{ borderRadius: 16 }}>
      <Skeleton
        className='itemImage'
        height='100%'
        width='100%'
        style={{ position: 'absolute', zIndex: -1 }}
      />
      <div className='contentDiv'>
        {!hideItemName && <Skeleton width={120} height={20} />}
        {!hideItemDescription && (
          <Skeleton width={180} height={19} style={{ marginTop: 4 }} />
        )}
        {!hideItemPrice && (
          <Skeleton width={60} height={19} style={{ marginTop: 4 }} />
        )}
      </div>
    </div>
  </div>
)

export default MenuCardSkeleton
